var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ibx-item"},[(_vm.hasError)?_c('IbxItemError',{attrs:{"message":_vm.errorMessage}}):_c('pie-player',{ref:"player",staticClass:"ibx-vendor-item",on:{"load-complete":_vm.onLoaded,"player-error":_vm.onError}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }